module.exports = __webpack_public_path__ + "static/media/integrator-process.6adbcd2e.png";